import React, { useState } from 'react';

const AnswerWithText = ({
  questionNumber = "",
  question = "",
  correctAnswer = "",
  onCalculateScore
}) => {
  const [answer, setAnswer] = useState("");

  const handleInputChange = (value) => {
    setAnswer(value);
    onCalculateScore(0, questionNumber, value, correctAnswer);
  };

  return (
    <div className="p-2 w-[700px] bg-white font-inter">
      {/* Question Number */}
      <div className="px-3 py-1 text-sm font-normal flex items-center mb-1">
        <b>{questionNumber}.</b><span className="ml-2"></span>{question}
        <span className="ml-2"></span>
        <input
          type="text"
          className="ml-auto px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
          value={answer}
          onChange={(e) => handleInputChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default AnswerWithText;
